module.exports = "<!-- image -->\n<span class=\"image\" *ngIf=\"images.length > 0\">\n    <img class=\"quiz-image\" [src]=\"images[0].sizes.quiz.urlWithParams\" alt=\"\">\n    <!-- caption -->\n    <span class=\"caption\" [innerHtml]=\"images[0].caption\"></span>\n    <!-- next -->\n    <a class=\"next-button\">{{nextText}}</a>\n    <!-- share -->\n</span>"


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/preview/parts/image-quiz.component.html
// module id = ../../../../../src/swarm/src/app/slideshow/tabs/preview/parts/image-quiz.component.html
// module chunks = main